import MainLayout from "../../layout/MainLayout";
import DataTable from "../../common/Tables/DataTable";
import { actionPost, useApiCall } from "../../services/api";
import useExpiredToken from "../../utils/useExpiredToken";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getAssignedQAColumns, ShowData } from "../../utils/ShowData";
import { useNavigate } from "react-router-dom";
import { useToast } from "../../utils/Toast";
import AuditType from "../../components/models/AuditType";
import { processEncryptedResponse } from "../../utils/ResponseDecreypt";
import AssignedCallDetails from "../../components/models/AssignedCallDetails";
import { filterDataFunc, qaTypeButtons ,QA_ROLES, ASSIGNED_QA_VISIBLE_ROLES} from "../../constant";
import FilterSection from "../../components/FilterSection";
import AppSelect from "../../common/FormInputs/AppSelect";
import { Button, Dropdown, Space, Tag } from "antd";
import { DatePicker } from "antd";
import {
  DeleteOutlined,
  DownloadOutlined,
  EllipsisOutlined,
  EyeOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import DateRangeFilter from "../../components/filters/DateRangeFilter";
import dayjs from "dayjs";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const AuditedCalls = ({ isCalibrationMode = false }) => {
  const [data, setData] = useState([]);
  const token = useSelector((state) => state.auth.jwtToken);
  const expireToken = useExpiredToken();
  const { callApi } = useApiCall();
  const role = useSelector((state) => state.auth.role);
  const { searchText } = useSelector((state) => state.search);
  const [deleteData, setDeleteData] = useState({});
  const navigate = useNavigate();
  const toast = useToast();
  const [isAudit, setIsAudit] = useState(false);
  const [auditType, setAuditType] = useState(null);
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [qaList, setQAList] = useState([]);
  const [selectedQA, setSelectedQA] = useState(null);
  const [dateRange, setDateRange] = useState(null); 
  const { RangePicker } = DatePicker;
  const [selectedAuditType, setSelectedAuditType] = useState(null);
  const [auditTypeTouched, setAuditTypeTouched] = useState(false);
  const handleCancel = () => {
    setIsAudit(false);
    setIsDetailsModalOpen(false);
  };

  // const fetchData = async () => {
  //   const res = await actionPost("calls/summary", token, "AUDITED_CALLS", {}, expireToken);
  //   const data = await processEncryptedResponse(res);
  //   if (data) {
  //     setData(data);
  //   }
  // };

  const mappedData = data?.map((item, index) => ShowData(item, role, index));
  const filteredData = filterDataFunc(mappedData, searchText);

  const handleAuditCall = (record) => {
    setDeleteData(record?.originalItem);
  };

  const fetchAllQA = async () => {
    const { decrypted, status } = await callApi({
      endpoint: "superadmin/users/qa/dynamic",
      queryParams: {
        qaId: selectedQA,
      },
      showToast: false,
    });

    if (status) {
      const mappedQAList = decrypted?.users?.map((qa) => ({
        label: `${qa.full_name} (${qa.email})`,
        value: qa.username,
      }));
      setQAList(mappedQAList);
    }
  };

  // useEffect(() => {
  //   fetchAllQA();
  // }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [selectedQA]);

  const handleRedirect = (type) => {
    if (type == "back") {
      setIsAudit(false);
    } else {
      if (auditType) {
        navigate(`/audit-details/${deleteData?.id}`, {
          state: { record: deleteData, auditType },
        });
      } else {
        toast.error("Audit type not selected!");
      }
    }
  };

  const auditTypeOptions =
    deleteData?.assigned_users?.audit_types
      ?.filter((item) => item?.status === false)
      ?.map((item) => ({
        label: item?.audit_type_name,
        value: item?.audit_type_id,
      })) || [];

  const handleView = (record) => {
    setSelectedRow(record);
    setIsDetailsModalOpen(true);
  };


const extractAuditQnAMap = (audit) => {
  const map = {};

  (audit.auditQnA || []).forEach(q => {
    if (q.question) {
      map[q.question] = q.answer ?? "--";
    }
  });

  return map;
};

const extractEvaluationQnAMap = (audit) => {
  const map = {};

  (audit.evaluation || []).forEach(cat => {
    (cat.questions || []).forEach(q => {
      const questionKey = `${cat.categoryName} - ${q.question}`;
      map[questionKey] = q.weightage ?? "--";
    });
  });

  return map;
};

const collectAllQuestions = (calls) => {
  const questionSet = new Set();

  calls.forEach(d => {
    const qnaMap =
      d.auditType === "Transactional"
        ? extractEvaluationQnAMap(d)
        : extractAuditQnAMap(d);

    Object.keys(qnaMap).forEach(q => questionSet.add(q));
  });

  return Array.from(questionSet);
};


const handleDownloadAllAudits = async () => {
  try {
    if (!dateRange || dateRange.length !== 2) {
      toast.error("Please select date range first");
      return;
    }
    const fromDate = dateRange?.[0]?.format("YYYY-MM-DD");
    const toDate = dateRange?.[1]?.format("YYYY-MM-DD");

    const response = await callApi({
      endpoint: "call-audits/export/audited-calls",
      apiMethod: "post",
      queryParams: {
        fromDate,
        toDate,
        auditTypeId: selectedAuditType || null,
      },
    });

    const calls = response?.responseData?.data || [];
    if (!calls.length) {
      toast.info("No audited calls found");
      return;
    }

    //  STEP 1: collect all questions
    const allQuestions = collectAllQuestions(calls);

    // STEP 2: build rows
    const allAuditData = calls.map(d => {
      const qnaMap =
        d.auditType === "Transactional"
          ? extractEvaluationQnAMap(d)
          : extractAuditQnAMap(d);

      const baseRow = {
        "Call ID": d.callId,
        "Actual Call ID": d.actualCallId,
        "Audit ID": d.auditId,
        "Audit Type": d.auditType,
        "Auditor": d.auditorName,
        "Agent Name": d.agentName,
        "Employee ID": d.empId,
        "Site/Circle": d.center,
        "Call Date": d.callDate,
        "Audit Date": d.auditDate,
        "Call Type": d.callType,
        "Duration": d.duration,
        "Hang Up By": d.hangUpBy,
        "NC Call": d.ncCall ? "Yes" : "No",
        "Remarks": d.remarks,
        "Mobile Number": d.mobileNumber,
        "Recording URL": d.recPath,
      };

      // STEP 3: add dynamic question columns
      allQuestions.forEach(q => {
        baseRow[q] = qnaMap[q] ?? "--";
      });

      return baseRow;
    });

    //Excel export
    const ws = XLSX.utils.json_to_sheet(allAuditData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "All Audits");

    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout]), "AllAudits.xlsx");

    toast.success(`Downloaded ${allAuditData.length} audits`);
  } catch (err) {
    console.error(err);
    toast.error("Failed to download audits");
  }
};

const handleDownloadRecording = async (record) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_BASE_URL}/call-audits/${record?.id}/download`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download recording");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = `call-recording-${record?.["Agent ID"] || "agent"}.ogg`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);

    toast.success("Recording downloaded");
  } catch (err) {
    toast.error("Cannot download recording: " + err.message);
  }
};


  const columns = [
    {
      title: "Call ID",
      dataIndex: "Call ID",
      key: "Call ID",
      width: 100,
    },
    {
      title: "Call date",
      dataIndex: "Call date",
      key: "Call date",
      width: 134,
      // filterDropdown: (props) => <DateRangeFilter {...props} />,
      // onFilter: (value, record) => {
      //   if (!value || value.length !== 2) return true;

      //   const [start, end] = value;
      //   const recordDate = dayjs(record["Call date"]);

      //   return recordDate.valueOf() >= start.valueOf() && recordDate.valueOf() <= end.valueOf();
      // },
    },
    {
      title: "Start time",
      dataIndex: "Start time",
      key: "Start time",
      width: 134,
    },
    {
      title: "End time",
      dataIndex: "End time",
      key: "End time",
      width: 134,
    },
    {
      title: "Agency name",
      dataIndex: "Agency name",
      key: "Agency name",
      width: 134,
    },
    {
      title: "Call duration",
      dataIndex: "Call duration",
      key: "Call duration",
    },
    {
      title: "Call type",
      dataIndex: "Call type",
      key: "Call type",
      width: 134,
    },
    {
      title: "Agent ID",
      dataIndex: "Agent ID",
      key: "Agent ID",
      width: 134,
    },
    {
      title: "Disconnected by",
      dataIndex: "Disconnected by",
      key: "Disconnected by",
      // filters: [
      //   { text: "Customer", value: "CUSTOMER" },
      //   { text: "Agent", value: "AGENT" },
      // ],
      // onFilter: (value, record) => value && record["Disconnected by"] === value,
    },
    {
      title: "Disposition",
      dataIndex: "Disposition",
      key: "Disposition",
      width: 350,
    },
    
    ASSIGNED_QA_VISIBLE_ROLES.includes(role) &&  {
      title: "Audited QA",
      key: "assigned_users",
      render: (_, record) => {
        const user = record?.originalItem?.assigned_user;
        return user ? (
          <Tag key={user.user_id || user.id} color="geekblue">
            {user.username} - ({user.audit_type_name})
          </Tag>
        ) : (
          <span>-</span>
        );
      },
    },
    {
      dataIndex: "assigned_users_text",
      key: "assigned_users_text",
      hidden: true,
    },
    {
      title: "Call status",
      dataIndex: "Call status",
      key: "Call status",
      render: (status) => <Tag color={status === "COMPLETED" ? "green" : "red"}>{status}</Tag>,
      // filters: [
      //   { text: "COMPLETED", value: "COMPLETED" },
      //   { text: "PENDING", value: "PENDING" },
      // ],
      // onFilter: (value, record) => record["Call status"] === value,
    },
    {
      title: "Customer phone number",
      dataIndex: "Customer phone number",
      key: "Customer phone number",
    },
    {
      title: "Audit Type",
      key: "assigned_users",
      render: (_, record) => {
        const auditType = record?.originalItem?.assigned_user;

        return (
          auditType && (
            <Tag key={auditType.audit_type_id} color="geekblue">
              {auditType.audit_type_name}
            </Tag>
          )
        );
      },
      // filters: qaTypeButtons.map((item) => ({ text: item.label, value: item.id })),
      // onFilter: (value, record) => record?.originalItem?.assigned_user?.audit_type_id === value,
    },
    {
      title: "Download Recording",
      key: "recording_download",
      width: 170,
      render: (_, record) => (
        <Button
          icon={<DownloadOutlined />}
          size="small"
          style={{
            backgroundColor: "#ffffff",   // slightly different shade from report
            color: "#0d3b66",
            border: "1px solid #c7cbcf",
            height: "30px",
            padding: "8px 20px",
            fontWeight: 500,
            borderRadius: "6px",
          }}
          onClick={() => handleDownloadRecording(record)}
        >
          Recording
        </Button>
      ),
    },
    // {
    //   title: "Download Report",
    //   key: "Action",
    //   render: (_, record) => (
    //   <Button
    //     icon={<DownloadOutlined />}
    //     onClick={() => {
    //       const width = window.screen.availWidth;
    //       const height = window.screen.availHeight;
          
    //       // Pass isCalibrationMode as query parameter
    //       window.open(
    //         `/report-pdf?callId=${record.id}&auditTypeId=${record?.originalItem?.assigned_user?.audit_type_id}&isCalibrationMode=${isCalibrationMode}`,
    //         "_blank",
    //         `width=${width},height=${height},left=0,top=0`
    //       );
    //     }}
    //   >
    //     View Report
    //   </Button>
    //   ),
    // },
    // ATA Report column - show for everyone EXCEPT when QA role AND calibration mode is true
    !((role === 'qa' && isCalibrationMode) ||['traininglead', 'trainer', 'opslead', 'opsteamlead'].includes(role)) && {
      title: "ATA Report",
      key: "ata_report",
      width: 120,
      render: (_, record) => {
        const auditTypeId = record?.originalItem?.assigned_user?.audit_type_id;
        const width = window.screen.availWidth;
        const height = window.screen.availHeight;
        
        return (
          <Button
            icon={<DownloadOutlined />}
            size="small"
            style={{
              backgroundColor: "#ffffff",
              color: "#0d3b66",
              border: "1px solid #c7cbcf",
              height: "30px",
              padding: "4px 12px",
              fontWeight: 500,
              borderRadius: "6px",
            }}
            onClick={() => {
              const isAuditPage = ['qualityassurance', 'qualitylead', 'super_admin'].includes(role);
              const url = `/report-pdf?callId=${record.id}&auditTypeId=${auditTypeId}&isCalibrationMode=false${isAuditPage ? '&isAuditPage=true' : ''}`;
              window.open(url, "_blank", `width=${width},height=${height},left=0,top=0`);

            }}
          >
            Download
          </Button>
        );
      },
    },
    // Calibration Report column - show for everyone EXCEPT when QA role AND calibration mode is false
    !(role === "qa" && !isCalibrationMode) && {
      title: "Calibration Report",
      key: "calibration_report",
      render: (_, record) => {
        const auditTypeId = record?.originalItem?.assigned_user?.audit_type_id;
        const width = window.screen.availWidth;
        const height = window.screen.availHeight;
        
        return (
          <Button
            icon={<DownloadOutlined />}
            size="small"
            style={{
              backgroundColor: "#ffffff",
              color: "#0d3b66",
              border: "1px solid #c7cbcf",
              height: "30px",
              padding: "4px 12px",
              fontWeight: 500,
              borderRadius: "6px",
            }}
            onClick={() => {
              const isAuditPage = ['qualityassurance', 'qualitylead', 'super_admin'].includes(role);
              window.open(
                `/report-pdf?callId=${record.id}&auditTypeId=${auditTypeId}&isCalibrationMode=true${isAuditPage ? '&isAuditPage=true' : ''}`,
                "_blank",
                `width=${width},height=${height},left=0,top=0`
              );
            }}
          >
            Download
          </Button>
        );
      },
    },
    // (role === "qualityassurance" || role === "qualitylead" || role === "super_admin") && {
    //   title: "Ops Team Lead Report",
    //   key: "ops_team_lead_report",
    //   render: (_, record) => {
    //     const auditTypeId = record?.originalItem?.assigned_user?.audit_type_id;
    //     const width = window.screen.availWidth;
    //     const height = window.screen.availHeight;

    //     return (
    //       <Button
    //         icon={<DownloadOutlined />}
    //         size="small"
    //         style={{
    //           backgroundColor: "#ffffff",
    //           color: "#0d3b66",
    //           border: "1px solid #c7cbcf",
    //           height: "30px",
    //           padding: "4px 12px",
    //           fontWeight: 500,
    //           borderRadius: "6px",
    //         }}
    //         onClick={() => {
    //           window.open(
    //             `/report-pdf?callId=${record.id}&auditTypeId=${auditTypeId}&roleId=6`,
    //             "_blank",
    //             `width=${width},height=${height},left=0,top=0`
    //           );
    //         }}
    //       >
    //         Download
    //       </Button>
    //     );
    //   },
    // },
    // (role === "qualityassurance" || role === "qualitylead" || role === "super_admin") && {
    //   title: "Ops Lead Report",
    //   key: "ops_team_lead_report",
    //   render: (_, record) => {
    //     const auditTypeId = record?.originalItem?.assigned_user?.audit_type_id;
    //     const width = window.screen.availWidth;
    //     const height = window.screen.availHeight;

    //     return (
    //       <Button
    //         icon={<DownloadOutlined />}
    //         size="small"
    //         style={{
    //           backgroundColor: "#ffffff",
    //           color: "#0d3b66",
    //           border: "1px solid #c7cbcf",
    //           height: "30px",
    //           padding: "4px 12px",
    //           fontWeight: 500,
    //           borderRadius: "6px",
    //         }}
    //         onClick={() => {
    //           window.open(
    //             `/report-pdf?callId=${record.id}&auditTypeId=${auditTypeId}&roleId=7`,
    //             "_blank",
    //             `width=${width},height=${height},left=0,top=0`
    //           );
    //         }}
    //       >
    //         Download
    //       </Button>
    //     );
    //   },
    // },
    // (role === "qualityassurance" || role === "qualitylead" || role === "super_admin") && {
    //   title: "Trainer Report",
    //   key: "trainer_report",
    //   render: (_, record) => {
    //     const auditTypeId = record?.originalItem?.assigned_user?.audit_type_id;
    //     const width = window.screen.availWidth;
    //     const height = window.screen.availHeight;

    //     return (
    //       <Button
    //         icon={<DownloadOutlined />}
    //         size="small"
    //         style={{
    //           backgroundColor: "#ffffff",
    //           color: "#0d3b66",
    //           border: "1px solid #c7cbcf",
    //           height: "30px",
    //           padding: "4px 12px",
    //           fontWeight: 500,
    //           borderRadius: "6px",
    //         }}
    //         onClick={() => {
    //           window.open(
    //             `/report-pdf?callId=${record.id}&auditTypeId=${auditTypeId}&roleId=8`,
    //             "_blank",
    //             `width=${width},height=${height},left=0,top=0`
    //           );
    //         }}
    //       >
    //         Download
    //       </Button>
    //     );
    //   },
    // },
    // (role === "qualityassurance" || role === "qualitylead" || role === "super_admin") && {
    //   title: "Training Lead Report",
    //   key: "training_lead_report",
    //   render: (_, record) => {
    //     const auditTypeId = record?.originalItem?.assigned_user?.audit_type_id;
    //     const width = window.screen.availWidth;
    //     const height = window.screen.availHeight;

    //     return (
    //       <Button
    //         icon={<DownloadOutlined />}
    //         size="small"
    //         style={{
    //           backgroundColor: "#ffffff",
    //           color: "#0d3b66",
    //           border: "1px solid #c7cbcf",
    //           height: "30px",
    //           padding: "4px 12px",
    //           fontWeight: 500,
    //           borderRadius: "6px",
    //         }}
    //         onClick={() => {
    //           window.open(
    //             `/report-pdf?callId=${record.id}&auditTypeId=${auditTypeId}&roleId=9`,
    //             "_blank",
    //             `width=${width},height=${height},left=0,top=0`
    //           );
    //         }}
    //       >
    //         Download
    //       </Button>
    //     );
    //   },
    // },
].filter(Boolean);

  return (
    <>
      <>
        <div className="container-fluid">
          {/* <div className="">
            <FilterSection />
          </div> */}
          {/* QA filter */}
          {/* <div className="pb-3 col-12 col-sm-3">
            <AppSelect
              label=""
              name="batch_number"
              type="text"
              placeholder="Select QA"
              options={qaList}
              value={selectedQA}
              rules={[{ required: true, message: "Please select the item!" }]}
              onChange={handleOnChange}
              allowClear
            />
          </div> */}
        
        <div
            style={{
              display: "flex",
              flexWrap: "wrap",   
              gap: "12px",
              alignItems: "center",
              padding: "8px",
              marginBottom: "16px",
              width: "100%",
            }}
          >
            <div style={{ flexGrow: 1, minWidth: "200px", display: "flex", flexDirection: "column" }}>
              <span style={{ fontSize: "20px", color: "#052659" }}>Audited Calls</span>
              <span style={{ fontSize: "14px", color: "#6b7280" }}>
                Select audit type and date range to download calls
              </span>
            </div>

            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "12px",
                alignItems: "center",
                flexGrow: 2,
              }}
            >
              {/* Audit Type dropdown */}
              <div style={{ flex: "1 1 180px", minWidth: 180 }}>
                <AppSelect
                  placeholder="Audit Type"
                  options={qaTypeButtons.map((item) => ({
                    value: item.id,
                    label: item.label,
                  }))}
                  value={selectedAuditType}
                  onChange={(val) => {
                    setSelectedAuditType(val);
                    setAuditTypeTouched(true);
                  }}
                  allowClear
                  style={{ width: "100%", height: "40px" }}
                />
                {auditTypeTouched && !selectedAuditType && (
                  <div style={{ color: "red", fontSize: 12, marginTop: 4 }}>
                    Please select Audit Type
                  </div>
                )}
              </div>
              {/* Date range picker */}
              <div style={{ flex: "2 1 300px", minWidth: 220 }}>
                <RangePicker
                  value={dateRange}
                  onChange={(dates) => setDateRange(dates)}
                  allowClear
                  format="YYYY-MM-DD"
                  style={{ width: "100%", height: "40px" }}
                />
              </div>
              {/* Download button */}
              <div style={{ flex: "0 1 150px", minWidth: 120 }}>
                <Button
                  type="primary"
                  icon={<DownloadOutlined />}
                  style={{ width: "100%", height: "40px", backgroundColor: "#052659", color: "#fff", border: "none" }}
                  onClick={() => {
                    if (!selectedAuditType) {
                      setAuditTypeTouched(true);
                      toast.error("Please select Audit Type first");
                      return;
                    }
                    handleDownloadAllAudits();
                  }}
                >
                  Download
                </Button>
              </div>
            </div>
          </div>
          <DataTable
           key={isCalibrationMode ? "calibration-mode" : "normal-mode"} 
            updatedColumns={columns}
            callApiArgs={{
              endpoint: "calls/summary",
              bodyData: {
               action: isCalibrationMode ? "CALIBARATION_QA_AUDITED" : "AUDITED_CALLS", 
                input: {},
              },
              apiMethod: "post",
            }}
          />
        </div>
      </>
      <AuditType
        handleCancel={handleCancel}
        open={isAudit}
        handleBack={handleRedirect}
        auditType={auditType}
        setAuditType={setAuditType}
        auditTypeOptions={auditTypeOptions}
      />

      <AssignedCallDetails
        open={isDetailsModalOpen}
        handleCancel={handleCancel}
        formData={selectedRow}
      />
    </>
  );
};

export default AuditedCalls;
